export default __webpack_public_path__ + "static/media/dropdown-up.2c1dbcfc.svg";